import { lazy } from "react";
import { Outlet } from "react-router-dom";
import { IssuerGuard } from "src/guards/issuer-guard";
import { GuestGuard } from "src/guards/guest-guard";
import { Layout as AuthLayout } from "src/layouts/auth/classic-layout";
import { Issuer } from "src/utils/auth";

// JWT
const JwtLoginPage = lazy(() => import("src/pages/auth/jwt/login"));
const JwtRegisterPage = lazy(() => import("src/pages/auth/jwt/register"));
const JwtVerifyPage = lazy(() => import("src/pages/auth/jwt/verify"));
const JwtForgotPage = lazy(() => import("src/pages/auth/jwt/forgot"));
const JwtForgotVerifyPage = lazy(() =>
  import("src/pages/auth/jwt/forgot-verify")
);
const JwtResetPage = lazy(() => import("src/pages/auth/jwt/reset"));
const JwtKakaoCallbackPage = lazy(() =>
  import("src/pages/auth/jwt/kakao-callback")
);
const JwtNaverCallbackPage = lazy(() =>
  import("src/pages/auth/jwt/naver-callback")
);
const JwtGoogleCallbackPage = lazy(() =>
  import("src/pages/auth/jwt/google-callback")
);

export const authRoutes = [
  {
    path: "auth",
    children: [
      {
        path: "jwt",
        element: (
          <IssuerGuard issuer={Issuer.JWT}>
            <GuestGuard>
              <AuthLayout>
                <Outlet />
              </AuthLayout>
            </GuestGuard>
          </IssuerGuard>
        ),
        children: [
          {
            path: "login",
            element: <JwtLoginPage />,
          },
          {
            path: "register",
            element: <JwtRegisterPage />,
          },
          {
            path: "verify",
            element: <JwtVerifyPage />,
          },
          {
            path: "forgot",
            element: <JwtForgotPage />,
          },
          {
            path: "forgot-verify",
            element: <JwtForgotVerifyPage />,
          },
          {
            path: "reset",
            element: <JwtResetPage />,
          },
          {
            path: "kakao-callback",
            element: <JwtKakaoCallbackPage />,
          },
          {
            path: "naver-callback",
            element: <JwtNaverCallbackPage />,
          },
          {
            path: "google-callback",
            element: <JwtGoogleCallbackPage />,
          },
        ],
      },
    ],
  },
];
